import { render } from "./KeywordModal.vue?vue&type=template&id=78c618a4"
import script from "./KeywordModal.vue?vue&type=script&lang=js"
export * from "./KeywordModal.vue?vue&type=script&lang=js"

import "./KeywordModal.vue?vue&type=style&index=0&id=78c618a4&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__